export const UPDATE_FIELD = "UPDATE_FIELD";
export const UPDATE_QUESTION_FIELD = "UPDATE_QUESTION_FIELD";
export const DELETE = "DELETE";
export const SET_GROUP = "SET_GROUP";
export const SET_COLOR = "SET_COLOR";
export const SET_QUESTION = "SET_QUESTION";
export const NEW_QUESTION = "NEW_QUESTION";
export const ADD_NEW_QUESTION_OPTION = "ADD_NEW_QUESTION_OPTION";
export const GET_AVAILABLE_GROUPS = "GET_AVAILABLE_GROUPS";